<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-0" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              Paieška
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-3">
              <v-col cols="12" md="4">
                <el-text-field
                  label="Identifikavimo kodas (IDK)"
                  v-model="extraData.obj_identifikavimo_kodas"
                  idk
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Dokumento numeris"
                  v-model="extraData.obj_dokumento_numeris"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="busenaList"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Būsena"
                  v-model="extraData.busena"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="objektasList"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="false"
                  label="Objekto rūšis"
                  v-model="extraData.objektas"
                  @change="objektasChange()"
                />
              </v-col>
              <v-col cols="12" md="8">
                <el-autocomplete
                  :items="veiksmasList"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  :readonly="!enableVeiksmas"
                  label="Veiksmai"
                  v-model="extraData.veiksmas"
                  @change="veiksmasChange()"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Šalies (pirmos) kodas arba pavadinimas"
                  v-model="extraData.obj_skolininko_pavadinimas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Šalies (antros) kodas arba pavadinimas"
                  v-model="extraData.obj_kreditoriaus_pavadinimas"
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-date-picker
                  label="Įregistravimo data nuo"
                  v-model="extraData.obj_iregistravimo_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-date-picker
                  label="Įregistravimo data iki"
                  v-model="extraData.obj_iregistravimo_data_iki"
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-date-picker
                  label="Išregistravimo data nuo"
                  v-model="extraData.obj_isregistravimo_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-date-picker
                  label="Išregistravimo data iki"
                  v-model="extraData.obj_isregistravimo_data_iki"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <el-button primary @click.native.stop="searchData()">
                  Ieškoti
                </el-button>
                <el-button @click.native="clearData()">
                  Išvalyti
                </el-button>
              </v-col>
            </v-row>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
import HipotekaMap from '../hipoteka/hipotekaMap'

export default {
  name: 'SavitarnaDokumentaiSearch',
  props: {
    loading: Boolean,
  },
  mixins: [userRole],
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    busenaList: [],
    mainData: {},
    extraData: {
      objektas: null,
      veiksmas: [],
    },
  }),
  computed: {
    ...mapGetters(['searchParams', 'savitarnaXid']),
    isExpanded() {
      return this.searchPanel === 0
    },
    objektasList() {
      return Object.entries(HipotekaMap['savitarnaObjektas'])
        .map(([key, item]) => {
          return {
            value: key,
            text: item.title,
            role: item.role,
          }
        })
        .filter(item => {
          return this.roleOr(item.role)
        })
    },
    veiksmasList() {
      return Object.entries(HipotekaMap['savitarnaVeiksmas'])
        .map(([key, item]) => {
          return {
            value: key,
            text: item.title,
            role: item.role,
          }
        })
        .filter(item => {
          return (
            this.roleOr(item.role) &&
            item.value.includes(this.extraData.objektas)
          )
        })
    },
    enableVeiksmas() {
      return this.extraData.objektas
    },
    savitarnaVeiksmasKey() {
      return this.$route.params.savitarnaVeiksmasKey ?? null
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    if (
      this.searchParams &&
      this.searchParams.route === this.$route.name &&
      this.searchParams.xid === this.savitarnaXid
    ) {
      this.mainData = this.searchParams.mainData
      this.extraData = this.searchParams.extraData
      this.searchPanel = this.searchParams.isExpanded ? 0 : null
    }
    if (this.$route.query.ntrRegistras) {
      this.mainData.reg_nr = this.$route.query.ntrRegistras.replace('-', '/')
    } else {
      this.mainData.reg_nr = null
    }
    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      if (this.savitarnaVeiksmasKey) {
        this.extraData.objektas = this.savitarnaVeiksmasKey
          .split('-')
          .slice(0, 2)
          .join('-')
        this.extraData.veiksmas = [this.savitarnaVeiksmasKey]
      }

      const data = {
        klasifikatoriai: ['busena_objektas'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.busenaList = res.data.list.busena_objektas

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        xid: this.savitarnaXid,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {
        objektas: null,
        veiksmas: [],
      }
    },
    submit() {
      this.searchData()
    },
    objektasChange() {
      this.extraData.veiksmas = []
    },
    veiksmasChange() {
      //
    },
  },
}
</script>
